var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 271,
    viewBox: "0 0 605 271",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_365_56972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.295 254.419V210.728H12V164.569C25.7935 139.67 40.5222 115.357 56.1861 91.6319C72.0837 67.9068 90.2024 42.8897 110.542 16.5806H170.509V164.569H195.057V210.728H170.509V254.419H112.295ZM112.295 164.569V85.2896C102.944 98.4441 94.0599 111.599 85.6435 124.753C77.2271 137.908 69.1614 151.18 61.4463 164.569H112.295Z",
    fill: "#DBBFA7",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.256 259C272.799 259 249.887 248.194 233.522 226.583C217.157 204.972 208.974 174.67 208.974 135.676C208.974 96.6824 217.157 66.3799 233.522 44.7689C250.121 22.923 273.266 12 302.958 12C332.415 12 355.326 22.8055 371.691 44.4165C388.057 65.7927 396.239 96.0951 396.239 135.324C396.239 174.318 387.94 204.737 371.341 226.583C354.742 248.194 331.714 259 302.256 259ZM302.256 206.147C312.543 206.147 319.907 200.627 324.349 189.586C329.025 178.311 331.363 160.223 331.363 135.324C331.363 110.424 329.025 92.4541 324.349 81.4137C319.907 70.3733 312.777 64.8531 302.958 64.8531C292.905 64.8531 285.54 70.4907 280.865 81.766C276.189 92.8065 273.851 110.777 273.851 135.676C273.851 160.341 276.072 178.311 280.514 189.586C285.19 200.627 292.437 206.147 302.256 206.147Z",
    fill: "#DBBFA7",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.239 254.419V210.728H409.943V164.569C423.737 139.67 438.466 115.357 454.129 91.6319C470.027 67.9068 488.146 42.8897 508.485 16.5806H568.452V164.569H593V210.728H568.452V254.419H510.239ZM510.239 164.569V85.2896C500.887 98.4441 492.003 111.599 483.587 124.753C475.17 137.908 467.105 151.18 459.39 164.569H510.239Z",
    fill: "#DBBFA7",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_365_56972",
    x: 0,
    y: 0,
    width: 605,
    height: 271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_365_56972"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_365_56972",
    result: "effect2_dropShadow_365_56972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_365_56972",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.55d1cb98.svg";
export { ForwardRef as ReactComponent };